export default __webpack_public_path__ + "static/customized-2421f5f670b248ac6cbcfe19a24455f4.png";